// 한글 초성 검색 유틸리티

// 한글 초성 목록
const CHO_HANGUL = [
  'ㄱ',
  'ㄲ',
  'ㄴ',
  'ㄷ',
  'ㄸ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅃ',
  'ㅅ',
  'ㅆ',
  'ㅇ',
  'ㅈ',
  'ㅉ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];

// 유니코드 한글 시작점
const HANGUL_START = 0xac00;
const HANGUL_END = 0xd7a3;
const CHO_PERIOD = 588; // 초성별 글자 수

/**
 * 문자가 한글인지 확인
 */
const isHangul = (char: string): boolean => {
  const code = char.charCodeAt(0);
  return code >= HANGUL_START && code <= HANGUL_END;
};

/**
 * 문자가 초성인지 확인
 */
const isChosung = (char: string): boolean => {
  return CHO_HANGUL.includes(char);
};

/**
 * 한글 문자에서 초성 추출
 */
const getChosung = (char: string): string => {
  if (!isHangul(char)) return char;
  const code = char.charCodeAt(0) - HANGUL_START;
  const chosungIndex = Math.floor(code / CHO_PERIOD);
  return CHO_HANGUL[chosungIndex] ?? char;
};

/**
 * 문자열에서 초성만 추출
 */
export const extractChosung = (str: string): string => {
  return str
    .split('')
    .map((char) => (isHangul(char) ? getChosung(char) : char))
    .join('');
};

/**
 * 초성 검색 또는 일반 문자열 검색 수행
 * @param target 검색 대상 문자열
 * @param query 검색어
 * @returns 매칭 여부
 */
export const matchKoreanSearch = (target: string, query: string): boolean => {
  if (!query) return true;

  const lowerTarget = target.toLowerCase();
  const lowerQuery = query.toLowerCase();

  // 일반 문자열 포함 검색
  if (lowerTarget.includes(lowerQuery)) return true;

  // 초성 검색 (검색어가 모두 초성인 경우)
  const isAllChosung = query
    .split('')
    .every((char) => isChosung(char) || !isHangul(char));
  if (isAllChosung) {
    const targetChosung = extractChosung(target);
    return targetChosung.includes(query);
  }

  return false;
};
